import { render, staticRenderFns } from "./RecursiveMenuItem.vue?vue&type=template&id=a6b83666&scoped=true&"
import script from "./RecursiveMenuItem.vue?vue&type=script&lang=js&"
export * from "./RecursiveMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveMenuItem.vue?vue&type=style&index=0&id=a6b83666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b83666",
  null
  
)

export default component.exports